import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concat, concatMap, of } from 'rxjs';
import { EntryCyclesActions } from '../actionstypes/entry-cycles/entry-cycles.actiontype';
import * as InitAction from '../actionstypes/init/init.actiontype';
import * as EntryCycleIdAction from '../actionstypes/selected-id/entry-cycle-id.actiontype';

@Injectable()
export class InitEffect {
  private actions$ = inject(Actions);

  loadInit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InitAction.InitAction.Load),
      concatMap(() => {
        const actions = [];

        // Check localStorage for selectedEntryCycleId, if any
        const storedEntryCycleId = localStorage.getItem('selectedEntryCycleId');
        if (storedEntryCycleId !== null) {
          const entryCycleId = Number(storedEntryCycleId);
          if (!isNaN(entryCycleId) && isFinite(entryCycleId)) {
            actions.push(new EntryCycleIdAction.Init(entryCycleId));
          }
        }

        actions.push(EntryCyclesActions.load());
        return concat(...actions.map((action) => of(action)));
      }),
    ),
  );
}
